// extracted by mini-css-extract-plugin
module.exports = {"component":"teaser-row_component__REgSQ","fourItems":"teaser-row_fourItems__QXuTM","threeItems":"teaser-row_threeItems__76ECh","twoItems":"teaser-row_twoItems__gq9BF"};